// 存储localStorage
import {GenderBoy, GenderGirl} from "@/common/constant";
import moment from 'moment'
import { jumpSignContract } from '@/util/application'
import Compressor from 'compressorjs';

/**
 * 压缩图片
 * @param {file} file 文件
 * @param {number} maxSize 压缩文件大小
 * @returns 
 */
export const compressFile = (file, maxSize) => {
  return new Promise((resolve, reject) => {
    // 递归循环大于定制的大小继续压缩
    const recursionFun = (img) => {
      if (!maxSize || img.size / 1024 / 1024 < maxSize) {
        console.log(`源文件大小：${file.size}；压缩大小：${img.size}；压缩要求：${maxSize}MB`)
        resolve(img)
        return
      }
      new Compressor(img, {
        mimeType: 'image/jpeg',
        quality: 0.9,
        maxWidth: 1920,
        maxHeight: 1080,
        success(result) {
          // console.log(Compressor, `源文件大小：${file.size}；压缩大小：${result.size}；压缩要求：${maxSize}`)
          recursionFun(result)
        },
        error(err) {
          console.log(err, 'error====')
          reject(err.message || '图片压缩失败')
        }
      })
    }

    recursionFun(file)
    // 压缩图片
    // new Compressor(file, {
    //   width: 595,
    //   // 如果图片大小（字节）小于该值，则不会尝试转换格式（即使指定了不同的 mimeType）。
    //   convertSize: 1,
    //   success(result) {
    //     console.log(file, '=====图片压缩成功', result)
    //     recursionFun(result)
    //   },
    //   error(err) {
    //     console.log('=====修改图片大小', err)
    //     reject(err.message || '图片修改大小失败')
    //   }
    // })
  })
};

export const setStore = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  try {
    window.localStorage.setItem(name, content)
  } catch (e) {
    console.log(e)
    return false
  }
}

// 获取localStorage
export const getStore = (name, isParse = false) => {
  if (!name) return
  try {
    let val = window.localStorage.getItem(name)
    isParse && val && (val = JSON.parse(val))
    return val
  } catch (e) {
    return false
  }
}

// 删除localStorage
export const removeStore = name => {
  if (!name) return
  window.localStorage.removeItem(name)
}

// js判断是否存在class
export function hasClass (obj, cls) {
  if (obj.className) {
    return obj.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
  }
  return false
}

// js 注册事件
export function addEvent (elem, type, listener, useCapture) {
  if (document.addEventListener) {
    elem.addEventListener(type, listener, useCapture)
  } else {
    elem.attachEvent('on' + type, listener)
  }
}

// 增加类
export function addClass (node, className) {
  let current = node.className || ''
  if ((' ' + current + ' ').indexOf(' ' + className + ' ') === -1) {
    node.className = current ? (current + ' ' + className) : className
  }
}
// 减少类
export function delClass (node, className) {
  let current = node.className || ''
  node.className = (' ' + current + ' ').replace(' ' + className + ' ', ' ').trim()
}

// 选择器
export function _sel (selector) {
  return [].slice.call(document.querySelectorAll(selector))
};

// 日期格式化
export function formatDate (date, fmt) { // author: meizz
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

export function isIE () {
  if (!!window.ActiveXObject || 'ActiveXObject' in window) { return true } else { return false }
}

/**
 * 手机号码正则验证  /^[1][3,4,5,6,7,8,9][0-9]{9}$/
 * @param mobile
 * @returns {boolean}
 */
export const getMobileTest = (mobile = '') => {
  return /^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(mobile) || false
}


//todo 全局 通用检查是不是移动环境
export const windowMatchMobile = () => {
  return /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|ArkWeb|deviceType)/i.test(navigator.userAgent)
    ||  document.body.clientWidth <= 1023 // mobile环境
}

/**
 * todo 身份证 获取 性别
 * @param idNumber
 * @returns {string|string}
 */
export const getGender = (idNumber)=> {
  // 获取身份证号的倒数第二位
  if(!idNumber) {
    return ""
  }
  const genderCode = idNumber.slice(-2, -1);
  // 判断性别
  return  ['1','3','5','7','9'].includes(genderCode) ? GenderBoy : ['2','4','6','8','0'].includes(genderCode) ? GenderGirl : ""
}

export const dealChartData = (data, xArr, yArr, fixed) => {
  if(!data || !data.length) return []
  const list = data.map((v, i) => ({
    name: v[xArr[0]],
    value: v[yArr[0]]
  }))
  return list
}

/**
 * 走势图日期取数
 * @param {*} x echarts x刻度
 * @param {*} d 接口数据
 * @param {*} o 开始时间
 * @param {*} n 接口日期字段
 * @returns 
 */
// const testArr = [
//   {
//     name: '2023-05-05'
//   },
//   {
//     name: '2023-05-22'
//   },
//   {
//     name: '2023-07-30'
//   },
//   {
//     name: '2024-06-28'
//   },
//   {
//     name: '2024-06-30'
//   },
// ]
export const dealDateData = (x, d, o, n = 'name') => {
  // console.log(x, d, o, n, '走势图日期取数-----');
  if(!d || !d.length) return { target: null, data: [] }
  let target; // 开始的边界日期
  let index; // 边界日期索引
  let data = []
  const newD = d.filter((v, i) => moment(v[n]).format('YYYY-MM') === moment(o).format('YYYY-MM'))
  const flag = moment(d[d.length - 1][n]).month() == moment(o).month()
  if (newD.length == 0 && flag) {
    target = d[d.length - 1][n]
  } else {
    // 取上一月非当天的最近过去日期
    if(newD.length > 1) {
      let closestDate = null;
      let minDiff = Infinity;
      const targetDate = moment(o, 'YYYY-MM-DD');
      newD.forEach(dateStr => {
        const date = moment(dateStr[n], 'YYYY-MM-DD');
        if (date.isBefore(targetDate)) {
          const diff = targetDate.diff(date);
          if (diff < minDiff) {
              minDiff = diff;
              closestDate = date;
          }
        }
      });
      target = closestDate ? moment(closestDate).format('YYYY-MM-DD') : null
    } else {
      if(newD[0] && moment(newD[0][n]).isBefore(o)) {
        target = newD[0][n]
      }
      // target = newD[0] ? newD[0][n] : null
    }
  }
  // console.log(target, 'target0-----');
  if (target) {
    index = x.indexOf(target)
  } else {
    const findOne = x.find((v,i) => moment(v).diff(moment(o)) >= 0 )
    if(findOne) {
      index = x.indexOf(findOne) - 1
    } else {
      index = x.length - 1
    }
  }
  data = d.filter((v, i) => i >= index)
  return {
    target,
    data
  }
}
// dealDateData(testArr.map(v => v.name), testArr, '2023-07-31')

export const getWatermarkName = (userInfo) => {
  let value = ''
  try {
    if (userInfo) {
      value = userInfo.customer_name
      if (userInfo.id_number) {
        // 取后四位,可用会包含一些特殊字符,需忽略但要加上显示
        // 如123456(B) 123456-(B) 123456(B)等
        let numValues = []
        let count = 0
        let len = userInfo.id_number.length
        for (let i = len - 1; i >= 0; i--) {
          const chart = userInfo.id_number[i]
          if (/[a-zA-Z0-9]$/.test(chart)) count += 1
          if (count < 5) {
            numValues.push(chart)
          } else {
            break
          }
        }
        value += ' ' + numValues.reverse().join('')
      }
    }
  } catch(e) {

  }
  return value
}

// 判断路由数据是否存在
export const textExistPath = (list, text) => {
  return !!list.find((item) => text.includes(item))
}

// 电子合同进行下一步的方法 参数path: 当前大模块的第一个路由
export const getNextPath = async (data, that) => {
  try {
    const {
      stepList,
      /**
       * 1:签名设置密码签署承诺函+上传资质证明+审核适当性+签署适当性+签署合同
       * 2:签名设置密码签署承诺函+签署合同
       * 3:签名设置密码签署承诺函+审核适当性+签署合同
       * 4:签名设置密码签署承诺函+审核适当性+签署适当性+签署合同
       * 5:认申购纸质合同
       * 6:追加
       */
      step_type,
      // 是否双录
      isDualRecord,
      isUploadCertFile,
      apply_id,
      step_list,
      isBasicInformation,
      review_flag,
    } = that.$store.state.base.reservationData;
    const index = stepList.findIndex(i => i.path.includes(data))
    //  -1:无需进行 0:待处理 1:已完成
    // 获取对应的状态
    const getStepStatus = (cnName) => (step_list.find(i => i.cn_name === cnName) || {}).status
    
    let path = stepList[index + 1].path
    // 是否有签名步骤
    const isSignature = stepList.find((_) => textExistPath(['/setSignature'], _.path))
    // 签署电子签名承诺函
    const signSignLetter = step_list.find((_) => _.cn_name === 'signSignLetter')
    // 身份信息认证成功跳转
    if (data === 'identityVerification') {
      // 是否需要跳过适当性单独处理
      if ([1, 3].includes(step_type) && review_flag) {
        if (getStepStatus('signAptnessDoc') === 0) {
          return '/fileList';
        }
        if (getStepStatus('dualRecord') === 0) {
          return '/pdfRecord';
        }
        await jumpSignContract(apply_id)
        return '';
      }
      // 判断是否签署了签名函
      if (signSignLetter && signSignLetter.status === 1 && isSignature) {
        // 角色是3的时候跳转到【等待页面】
        if ([3, 4].includes(step_type) || (step_type === 1 && !isUploadCertFile)) {
          return '/reservationSuccess?type=identitySuccess'
        }
        path = stepList[index + 2].path
      }
      // 角色是3没有签名步骤直接跳转到【等待页面】
      if ([3, 4].includes(step_type) && !isSignature) {
        return '/reservationSuccess?type=identitySuccess';
      }
    }
    // 设置签名图案和密码成功跳转
    if (data === 'setSignature') {
      if (step_type === 1 && isBasicInformation && !isUploadCertFile) {
        return `/basicInformation?apply_id=${apply_id}`;
      }
      if ([3, 4].includes(step_type) || (step_type === 1 && !isUploadCertFile)) {
        return '/reservationSuccess?type=signatureSuccess';
      }
    }
    // if (textExistPath(['/uploadFile'], path)) {
    //   // 步骤是4的时候跳转适当性的话转到签署适当性页面
    //   if (step_type === 4) return '/fileList'
    // }
    if (textExistPath(['/pdfRecord'], path)) {
      // 跳转双录的话判断是否双录完成了，完成的话跳转到签署合同
      if (!isDualRecord) {
        await jumpSignContract(apply_id)
        return '';
      }
    }
    return path
  } catch (error) {
    console.log('步骤条出错', error)
  }
}

// 对象转url入参
export const getSearchParams = (data) => {
  const list = Object.keys(data).map((key) => (`${key}=${data[key]}`));
  return `?${list.join('&')}`
}

// 是否横屏
export const isLandscapeScreen = () => {
  return window.matchMedia("(orientation: landscape)").matches;
}

export const toCamelCase = (str) => {
  let result = str.replace(/^\/|\/(.)/g, (match, letter) => {
      if (!letter) return '';
      return letter.toUpperCase();
  });
  return result.charAt(0).toLowerCase() + result.slice(1);
}


// 邮箱加密
export const maskEmail = (email) => {
  if (!email) return '';
  return email.replace(/^(.{1})(.*)(.{1})@/, '$1**$3@');
}

// 电话加密
export const maskPhone = (phone) => {
  if (!phone) return '';
  return phone.slice(0, 3) + '****' + phone.slice(7);
}